// Make the active year bold

(function () {
	"use strict";

	var yearLinks = document.querySelectorAll(".list-of-years a");

	for (var i = 0; i < yearLinks.length; ++i) {
		if (window.location.pathname === yearLinks[i].pathname) {
			yearLinks[i].classList.add("link--active");
		}
	}
}());

// Hide and show older years

(function () {
	"use strict";

	// hide old years
	var lis = Array.prototype.slice.call(document.querySelectorAll(".list-of-years li"));
	// Loop using "for" instead of "forEach" because it's faster (https://jsperf.com/fast-array-foreach)
	for (var i = 4; i < lis.length; ++i) {
		lis[i].classList.add("old-year");
	}

	// add "All" link
	var thirdLi = document.querySelector(".list-of-years li:nth-child(4)");

	if (thirdLi !== null) {
		var allLink = document.querySelector("li.all");
		allLink.classList.remove("hidden");
		allLink = allLink.parentNode.removeChild(allLink);
		thirdLi.insertAdjacentHTML("afterend", allLink.outerHTML);
		var allLinkHref = document.querySelector("li.all a");


		// when "All" link is clicked ...
		allLinkHref.addEventListener("click", function (event) {
			event.preventDefault();

			// remove the "All" link
			event.target.parentNode.removeChild(event.target);

			// unhide the older years
			for (var i = 3; i < lis.length; ++i) {
				lis[i].classList.remove("old-year");
			}
		});
	}
}());
